import { Router } from "@frui.ts/screens";
import { attachAutomaticValidator } from "@frui.ts/validation";
import { computed } from "mobx";
import EnumRepository from "repositories/enumRepository";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import OptionsService from "services/optionsService";
import { Modules, newNavigationName } from "config";
import Municipality, { MunicipalityValidationRules } from "entities/municipality";
import Region from "entities/region";
import CreateViewModel from "viewModels/createViewModel";

@Router.registerRoute({ name: Router.Self, route: newNavigationName })
export default class MunicipalityCreateViewModel extends CreateViewModel<Municipality> {
  readonly modelName = "municipality";

  constructor(
    protected repository: EnumRepository,
    protected localizationService: LocalizationService,
    protected notificationService: NotificationService,
    protected eventBus: EventBus,
    private optionsService: OptionsService
  ) {
    super();
    this.navigationName = newNavigationName;
  }

  @computed
  get regionOptions() {
    return this.optionsService.entityOptions(Region);
  }

  protected loadDetail(): Promise<Municipality> | Municipality {
    const entity = new Municipality();
    attachAutomaticValidator(entity, MunicipalityValidationRules);
    return entity;
  }

  protected postData() {
    return this.repository.create(this.item, "municipalities");
  }

  translate(code: string, size: number | undefined): string {
    return this.localizationService.translateModule(Modules.timeCharges, `municipalities.${code}`, size);
  }
}
